import { useEffect, useState } from "react";
import {
  Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext,
} from "./ui/carousel";

const CAR = "https://images.unsplash.com/photo-1785911872128-2bcd7d370121?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const DRIVER = "https://images.unsplash.com/photo-1562101074-ddc04071bdc8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
const BIKE = "https://images.unsplash.com/photo-1548695607-9c73430ba065?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const SLIDES = [
  { img: CAR, title: "Le confort à chaque trajet", sub: "Des véhicules propres et modernes, sélectionnés pour vous." },
  { img: DRIVER, title: "Des professionnels à votre service", sub: "Des chauffeurs vérifiés, courtois et ponctuels." },
  { img: BIKE, title: "Vos envois rapides et écologiques", sub: "Livraison de colis à vélo, en ville, sans émissions." },
];

export function EuropeAboutCarousel() {
  const [api, setApi] = useState(null);

  useEffect(() => {
    if (!api) return;
    const iv = setInterval(() => api.scrollNext(), 5000);
    return () => clearInterval(iv);
  }, [api]);

  return (
    <Carousel
      data-testid="europe-about-carousel"
      setApi={setApi}
      opts={{ loop: true }}
      className="mt-14"
    >
      <CarouselContent>
        {SLIDES.map((s, i) => (
          <CarouselItem key={i} data-testid={`europe-slide-${i}`}>
            <div className="relative overflow-hidden rounded-[2rem] h-[300px] sm:h-[420px] shadow-[0_10px_40px_rgba(0,0,0,0.12)]">
              <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
              <div className="absolute bottom-0 left-0 p-7 sm:p-10 max-w-xl">
                <h3 className="font-head font-black text-white text-2xl sm:text-4xl leading-tight [text-shadow:0_2px_16px_rgba(0,0,0,0.6)]">{s.title}</h3>
                <p className="mt-2 text-white/85 text-sm sm:text-base leading-relaxed">{s.sub}</p>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious
        data-testid="europe-carousel-prev"
        className="left-3 sm:left-5 h-9 w-9 bg-white/70 hover:bg-white border-0 text-[#1A1A1A] backdrop-blur transition-colors"
      />
      <CarouselNext
        data-testid="europe-carousel-next"
        className="right-3 sm:right-5 h-9 w-9 bg-white/70 hover:bg-white border-0 text-[#1A1A1A] backdrop-blur transition-colors"
      />
    </Carousel>
  );
}
